<template>
    <div class="course-dates">
        <div class="course-dates__item -highlight" v-if="lastUpdatedDate">
            <span class="icon-checked"></span>
            <span class="course-dates__label" v-html="$t('CourseDates.last_updated')"></span>
            <span class="course-dates__description">{{ formattedDateForCountry(lastUpdatedDate) }}</span>
        </div>
        <div class="course-dates__item" v-if="publishedDate">
            <span class="course-dates__label" v-html="$t('CourseDates.publish_date')"></span>
            <span class="course-dates__description">{{ formattedDateForCountry(publishedDate) }}</span>
        </div>
        <div class="course-dates__item" v-if="expirationDate">
            <span class="course-dates__label" v-html="$t('CourseDates.expiration_date')"></span>
            <span class="course-dates__description">{{ formattedDateForCountry(expirationDate) }}</span>
        </div>
    </div>
</template>

<script>
    import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'
    export default {
        props: {
            publishedDate: String,
            expirationDate: String,
            lastUpdatedDate: String
        },
        methods: { formattedDateForCountry }
    }
</script>

<style lang="scss" scoped>
    .course-dates {
        display: flex;
        position: relative;
        font-size: 1.4rem;
        padding: 0 0 25px;

        &__item {
            display: flex;
            align-items: center;
            @include white(background, 0.40);
            padding: 5px;

            &.-highlight {
                color: $chelsea_gem;
            }
        }

        [class*="mobile_sm"] & {
            flex-direction: column;
        }

        &__label {
            padding: 0 10px 0 0;
        }

        &__description {
            font-family: Nunito-ExtraBold, sans-serif;
            padding: 0 10px 0 0;
        }

        .icon-checked {
            padding: 0 8px 0 0;
        }
    }
</style>
